export default __webpack_public_path__ + "static/media/project3-iphone.1059d42c.png";